module.exports = __webpack_public_path__ + "img/author.f88c22fe.svg";